var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"linked-card"},[_c('router-link',{staticClass:"link",attrs:{"to":_vm.link_simcard()}},[_c('div',{staticClass:"linked-card_header"},[_c('span',{staticClass:"linked-card_header_name"},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"linked-card_footer"},[_c('span',{class:'mdi ' + _vm.icon})])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }